import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, Image,
    Text

} from "react-native";
import HMButton from "../../customviews/HMButton";
import HMTextView from "../../customviews/HMTextView";
import * as Colors from "../../tools/Colors";

var SpeechRecognition = null;
var recognition = null;
let container = null;

export default class AClass extends Component {
    constructor(props) {
        super();
        container = this;
        this.state = {
            values: "salam",

        };
    }

    componentWillMount() {
        if (Platform.OS === "web") {
            var voices = [];

            var speechSynthesis = window.speechSynthesis || window.webkitspeechSynthesis;
            if (speechSynthesis){
                speechSynthesis.onvoiceschanged = function () {
                    voices = speechSynthesis.getVoices();
                    console.log("voices@", voices);
                };
                /*      let msg = new SpeechSynthesisUtterance();
                      msg.voice = voices[0];
                      //msg.lang ='ar-SA';
                      msg.lang ='en-US';
                      // msg.text = "احمد خلیل";
                      msg.text = "Your problem seems to be not treating the Web Speech API asynchronously";
                      speechSynthesis.speak(msg);*/
            }



            SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            if (SpeechRecognition) {
                recognition = new SpeechRecognition();
                recognition.continuous = true;
                recognition.lang = 'fa-IR';
                recognition.interimResults = true;

                recognition.onresult = function (event) {
                    console.log("Value is ", event.results)
                    // setValues(event.results[0][0].transcript)
                    container.setState({values: event.results[0][0].transcript})

                }
            }
        }


        //    window.location = this.state.route.loc;
    }

    render() {


        return (<View>

            <View style={{flex: 1}}>
                <HMTextView
                    style={{
                        color: Colors.black,
                        fontSize: 20,
                        textAlign: "center"
                    }}
                    text={SpeechRecognition ? this.state.values : "ساپورت نمیکنه"}

                />
            </View>
            {
                SpeechRecognition ?
                    <View
                        sx={{
                            flex: 1
                        }}>
                        <HMButton
                            onPress={() => {
                                recognition.start()
                            }}
                            text="Start"
                        >Start</HMButton>

                        <HMButton
                            onPress={() => {
                                this.setState({values: "Click on the start button and start speaking."})
                            }}
                            text="Clear"
                        >Clear</HMButton>

                        <HMButton
                            onPress={() => {
                                recognition.abort()
                                recognition.stop()
                                console.log("Stop pressed")
                            }}
                            text="Stop"
                        >Stop</HMButton>

                    </View>
                    :
                    null
            }
        </View>);
    }
}

